<template>

    <div v-if="showTip" class="question__tip" v-html="questionTip">
    </div>

</template>

<script>
import { isString } from 'lodash';

export default {
    name: 'question-tip',

    props: {
        questionTip: [Boolean, String],
    },

    computed: {

        showTip()
        {
            return isString(this.questionTip);
        },
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-tip.vue